"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactGoogleCharts = _interopRequireDefault(require("react-google-charts"));
var _reactIntl = require("react-intl");
var _utils = require("../../utils");
var _Typography;
var _excluded = ["colors", "data", "height", "onClickCallback", "options", "pieChartClasses", "width"];
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    chart: {
      '& div.google-visualization-tooltip': {
        pointerEvents: 'none'
      },
      '& svg > g > g:last-child': {
        pointerEvents: 'none'
      },
      '& svg > text': {
        fill: theme.palette.text.primary,
        fontSize: theme.spacing(3)
      },
      '& svg text': {
        fill: theme.palette.text.primary
      },
      height: '100%'
    }
  };
});
var PieChart = function PieChart(_ref) {
  var colors = _ref.colors,
    data = _ref.data,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '400px' : _ref$height,
    onClickCallback = _ref.onClickCallback,
    options = _ref.options,
    pieChartClasses = _ref.pieChartClasses,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classes = useStyles();
  var theme = (0, _material.useTheme)();
  if (!data) {
    return _Typography || (_Typography = /*#__PURE__*/_react.default.createElement(_material.Typography, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "statistics.noResults"
    })));
  }
  return /*#__PURE__*/_react.default.createElement(_reactGoogleCharts.default, (0, _extends2.default)({
    chartEvents: [{
      callback: function callback(_ref2) {
        var chartWrapper = _ref2.chartWrapper;
        var selection = chartWrapper.getChart().getSelection();
        var row = 0;
        var column = 0;
        for (var i = 0; i < selection.length; i += 1) {
          var item = selection[i];
          if (item.row != null && item.column != null) {
            row = item.row;
            column = item.column;
          } else if (item.row != null) {
            row = item.row;
          } else if (item.column != null) {
            column = item.column;
          }
        }
        onClickCallback(chartWrapper.getDataTable().getValue(row, column));
      },
      eventName: 'select'
    }],
    chartType: "PieChart",
    className: (0, _classnames.default)({
      [classes.chart]: classes.chart,
      [pieChartClasses]: true
    }),
    data: data.length ? data : [['0', ''], ['No Value', 1]],
    height: height,
    options: (0, _utils.mergeDeep)({
      backgroundColor: 'transparent',
      chartArea: {
        height: '90%',
        width: '80%'
      },
      colors,
      is3D: false,
      legend: {
        alignment: 'center',
        position: 'labeled',
        textStyle: {
          color: theme.palette.text.primary,
          fontSize: 16
        }
      },
      pieHole: 0.4,
      pieSliceBorderColor: 'none',
      pieSliceText: 'none',
      titleTextStyle: {
        color: theme.palette.text.primary,
        fontName: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: '2rem'
      },
      tooltip: {
        isHtml: true
      }
    }, options || {}),
    width: width
  }, props));
};
var _default = exports.default = PieChart;